import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  inslabelListPath,
  InslabelListUrlQueryParams,
  InslabelListUrlSortField,
  inslabelPath,
  InstagramLabelPathUrlQueryParams
} from "./urls";
import InslabelDetailsComponent from "./views/InslabelDetails";
import InslabelListComponent from "./views/InslabelList";

const InslabelList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: InslabelListUrlQueryParams = asSortParams(
    qs,
    InslabelListUrlSortField
  );
  return <InslabelListComponent params={params} />;
};

const InslabeDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: InstagramLabelPathUrlQueryParams = qs;
  return (
    <InslabelDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const InslabelSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.label)} />
      <Switch>
        <Route exact path={inslabelListPath} component={InslabelList} />
        <Route path={inslabelPath(":id")} component={InslabeDetails} />
      </Switch>
    </>
  );
};

export default InslabelSection;
